import React from 'react';
import { motion } from 'framer-motion';
import { Bot, Sparkles } from 'lucide-react';

interface DroidButtonProps {
  onClick: () => void;
  hasNotifications?: boolean;
  isOpen?: boolean;
}

export function DroidButton({ onClick, hasNotifications = false, isOpen = false }: DroidButtonProps) {
  return (
    <motion.button
      onClick={onClick}
      className={`fixed bottom-6 right-24 w-14 h-14 rounded-full shadow-lg flex items-center justify-center z-40 transition-colors ${
        isOpen
          ? 'bg-surface-700 border border-surface-500'
          : 'bg-primary-500 hover:bg-primary-400'
      }`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      {/* Main Icon */}
      <Bot className={`w-6 h-6 ${isOpen ? 'text-text-secondary' : 'text-surface-900'}`} />

      {/* Notification indicator */}
      {hasNotifications && !isOpen && (
        <motion.div
          className="absolute -top-1 -right-1 w-5 h-5 bg-warning-500 rounded-full flex items-center justify-center"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 500, damping: 25 }}
        >
          <Sparkles className="w-3 h-3 text-surface-900" />
        </motion.div>
      )}

      {/* Pulse animation when has notifications */}
      {hasNotifications && !isOpen && (
        <motion.div
          className="absolute inset-0 rounded-full bg-primary-500"
          initial={{ scale: 1, opacity: 0.4 }}
          animate={{ scale: 1.5, opacity: 0 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeOut' }}
        />
      )}
    </motion.button>
  );
}
